<template>
  <b-modal
      id="modal-info-produto-id"
      title="Informações do Produto"
      ref="refModalInfoProduto"
      size="xl"
      no-close-on-esc
      hide-header
      hide-footer
      no-close-on-backdrop
  >
    <b-row class="pb-2" >
      <b-col cols="12" class="d-flex justify-content-between">
        <div class="d-flex px-0 flex-column" style="gap: 0">
          <span style="font-weight: bold">{{ item.item_name }} (Cod.Ref. {{ item.referencia}})</span>
          <b class="text-body" style="font-size: 10px">{{ item.item_marca }}</b>
          <span class="text-success" style="font-size: 16px">R$ {{ formatPrice(item.item_price) }}</span>
        </div>
        <div style="display: flex;gap: 10px">
          <div>
            <b-button
                variant="danger"
                @click="onCancelModal"
            >
              <feather-icon icon="XIcon" class="mr-50"/>
              Cancelar
            </b-button>
          </div>
          <div>
            <b-button
                variant="success"
                @click="adicionarCarrinho"
            >
              <feather-icon icon="ShoppingCartIcon" class="mr-50"/>
              Adicionar
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col cols="auto" class="imagens-container pr-0 mt-1">
        <div
            class="imagens-item"
        >
          <div
              v-if="item.imagens.length > 0"
              v-for="(img, index) in item.imagens.slice(0, 5)" :key="index">
            <div
                class="rounded imagens-item-img"
            >
              <b-img
                  :src="img.caminho ? img.caminho : imagemPadrao"
                  :alt="`${item.name}-${item.id}`"
                  class="img-fluid"
                  @click="item.item_img_princial = img.caminho"
                  @mouseover="item.item_img_princial = img.caminho"
              />
            </div>
          </div>
          <!-- Verificar se há mais imagens após a sexta -->
          <div
              v-if="item.imagens.length > 5"
              class="d-flex justify-content-center align-items-center bg-grey-1 rounded"
              style="border: 1px solid var(--primary); width: 50px; height: 50px;"
              @click="openModal(6)"
          >
            +{{ item.imagens.length - 5 }} <!-- Mostrar a quantidade restante -->
          </div>
        </div>
      </b-col>
      <b-col
          cols="12"
          sm="12"
          md="3"
          class="px-auto mt-1"
      >
        <b-img
            :src="item.item_img_princial ? item.item_img_princial : imagemPadrao"
            :alt="`${item.name}-${item.id}`"
            style="min-height: 350px;padding: 0;"
            class="img-fluid"
        />
      </b-col>

      <b-col cols="12" md="" class="mt-1">
        <grade-item
            :json="json || []"
            v-model="item.gradeItem"
            @update:grade="updatedGrade"
        />
      </b-col>

      <b-col cols="12" md="5">
        <b-tabs v-model="tabActive">
          <b-tab
              active
              title="Descrição"
          >
            <b-card-text class="text-justify">
              {{ item.item_descricao }}
            </b-card-text>
          </b-tab>
          <b-tab
              title="Características"
          >
            <b-card-text class="text-justify">
              {{ item.item_caracteristicas }}
            </b-card-text>
          </b-tab>
          <b-tab
              title="Composição"
          >
            <b-card-text class="text-justify">
              {{ item.item_composisao }}
            </b-card-text>
          </b-tab>
          <!--          <b-tab title="Indicações">-->
          <!--            <b-card-text>-->
          <!--              {{ item.item_indicacoes }}-->
          <!--            </b-card-text>-->
          <!--          </b-tab>-->
        </b-tabs>
      </b-col>
    </b-row>
    <b-modal
        id="modal-gallery-imagens"
        hide-footer
        hide-header
        style="height: 500px; width: 100%;background: transparent; border: none; padding: 0; margin: 0;"
        body-bg-variant="transparent"
    >
      <swiper
          ref="refSwiperGallery"
          class="swiper-gallery gallery-top"
          :options="swiperOptions"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      >
        <swiper-slide
            v-for="(data,index) in item.imagens"
            :key="index"
        >
          <b-img
              :src="data.caminho"
              fluid
          />
        </swiper-slide>

        <div
            slot="button-next"
            class="swiper-button-next swiper-button-white"
        />
        <div
            slot="button-prev"
            class="swiper-button-prev swiper-button-white"
        />
      </swiper>
    </b-modal>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { formtPriceBr } from '@core/utils/filter';
import 'swiper/css/swiper.css';
import GradeItem from '@/components/catalogo-produtos/GradeItem.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

export default {
  name: 'ModalInfoProduto',
  components: {
    GradeItem,
    Swiper,
    SwiperSlide,
  },
  filters: {
    formtPriceBr,
  },
  data() {
    return {
      tabActive: 0,
      showModal: true,
      slide: 0,
      imagemPadrao: IMAGEM_PADRAO,
      mainImg: IMAGEM_PADRAO,
      swiperOptions: {
        loop: true,
        loopedSlides: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      itemsCarrinho: [],
    };
  },
  computed: {
    ...mapGetters('ItemStore', {
      json: 'GET_GRADE_ATUAL',
    }),
    ...mapGetters('ItemStore', {
      item: 'GET_CURRENT_ITEM',
    }),
    ...mapGetters('slsEmbalagem', {
      currentEmbalagem: 'getCurrentEsEmbalag',
    }),
    ...mapGetters('PedidosStore', {
      pedidoItens: 'getItemPedido',
    }),
  },
  methods: {
    formatPrice(value) {
      const parsedValue = Number(value);
      if (Number.isNaN(parsedValue)) {
        return (0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return parsedValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    updatedGrade(value) {
      this.itemsCarrinho = value.map((item, index) => {
        console.log('ITEM', item);
        // const imagem = this.item.imagens.find(img => img.cdnCor === item.cdn_cor)
        const imagemPrincipal = this.item.imagens.find((item) => item.imagemPrincipal === 1);
        const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;
        const precoBase = parseFloat(this.item.item_price_base ?? this.item.item_price);
        const precoExibicao = parseFloat(this.item.item_price_exibicao ?? this.item.item_price);
        return {
          index: this.pedidoItens.length + 1,
          cod_marca: this.item.cod_marca,
          familia_comercial_id: this.item.referencia,
          familia_comercial_descricao: this.item.item_name,
          cdn_cor: item.cdn_cor,
          cdn_tamanho: item.cdn_tamanho,
          des_tamanho: item.tamanho,
          des_cor: item.des_cor,
          item_id: this.item.item_id,
          item_descricao: `${this.item.referencia} - ${this.item.item_name}`,
          // item_imagem: imagem ? imagem.caminho : 'https://dkpsales-novo-hanes.s3.amazonaws.com/images/images/produto-sem-imagem.png',
          item_imagem: caminhoImagemPrincipal,
          pedido_item_seq: this.$store.getters['PedidosStore/getLastSequenceItemPedido'] + 10,
          pic_id: 0,
          marca: this.item.item_marca,
          embalagem: this.currentEmbalagem.des_embalag,
          cdn_embalag: this.currentEmbalagem.cdn_embalag,
          pedido_item_preco_unitario: precoExibicao,
          pedido_item_preco_unitario_base: precoBase,
          pedido_item_quantidade: parseInt(item.valor, 10),
          valor_total: +(precoExibicao * parseFloat(item.valor)),
        };
      });
    },
    onCancelModal() {
      this.mainImg = IMAGEM_PADRAO;
      this.$refs.refModalInfoProduto.hide();
    },
    adicionarCarrinho() {
      const itemQtd = this.itemsCarrinho.filter((item) => item.pedido_item_quantidade > 0);
      for (const item of itemQtd) {
        this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', item);
      }
      this.$store.commit('ECommercerStore/ADD_OR_UPDATE_PRODUCT_TO_CART', {
        ...this.item,
        item_price: parseFloat(this.item.item_price),
        quantidade: 1,
      });
      this.$refs.refModalInfoProduto.hide();
    },
    openModal(startIndex) {
      this.showModal = true;
      // this.$refs.refSwiperGallery.$forceUpdate()
      this.$bvModal.show('modal-gallery-imagens');
      // this.$nextTick(() => {
      //   this.$refs.swiperTop.$swiper.slideTo(startIndex);
      // });
    },
  },
  mounted() {
    this.$nextTick(() => {
      // const swiperTop = this.$refs.refSwiperGallery.
    });
    this.mainImg = this.item.imagens[0]?.caminho ?? IMAGEM_PADRAO;
  },
};
</script>

<style scoped>
.destaque {
  border: 1px solid red;
}

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
}

.imagens-item-img img {
  height: 50px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
  }

  .imagens-item {
    flex-direction: row;
  }

  /* .imagens-item-img img {
    width: 100px;
    height: 100px;
  } */
}

/* Estilize a modal e o swiper conforme necessário */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
</style>
